// extracted by mini-css-extract-plugin
module.exports = {"legend":"a10a3f92e9--legend--mCk7Q","heat-index":"a10a3f92e9--heat-index--Gln4k","diagram":"a10a3f92e9--diagram--e0bWL"};